import { makeAutoObservable, runInAction } from 'mobx';
import { authApi } from '@helpers/AxiosHelper';
import { getDate } from '@helpers/DateHelper';

const SETTLEMENT_URL = '/api/statistics/settlement';

export const initial = {
  settlementList: {
    feeTotalAmount: 0,
    paidTotalAmount: 0,
    data: [],
  },

  settlementDetailList: [],
};

export function createSettlementStore(rootStore) {
  return makeAutoObservable({
    settlementList: initial.settlementList,
    settlementDetailList: initial.settlementDetailList,

    centerList: [],

    alertMessage: '',

    async getSettlementList(options) {
      try {
        const { data } = await authApi.get(
          SETTLEMENT_URL,
          { ...options },
          null,
        );

        runInAction(() => {
          let feeTotalAmount = 0;
          let paidTotalAmount = 0;

          data.map((item) => {
            feeTotalAmount += item.fee;
            paidTotalAmount += item.paidAmount;
          });

          this.settlementList = {
            feeTotalAmount,
            paidTotalAmount,
            data,
          };
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async getSettlementDetailList({
      enterpriseSeq,
      supplierSeq,
      processDt,
      rceptSe,
    }) {
      try {
        const { data } = await authApi.get(
          `${SETTLEMENT_URL}/view`,
          { enterpriseSeq, supplierSeq, processDt, rceptSe },
          null,
        );

        runInAction(() => {
          this.settlementDetailList = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    async getCenterList() {
      try {
        const { data } = await authApi.get(
          `${SETTLEMENT_URL}/support/centerList`,
          null,
          null,
        );

        runInAction(() => {
          this.centerList = data;
        });
        return true;
      } catch ({
        data: {
          data: { alertMessage },
        },
      }) {
        runInAction(() => {
          this.alertMessage = alertMessage;
        });
        return false;
      }
    },

    getAlertMessage() {
      const alertMessage = this.alertMessage;

      runInAction(() => {
        this.alertMessage = '';
      });

      return alertMessage;
    },
  });
}
